import _ from "lodash"
import moment from "moment"

import { opcionesHora } from "../Daily/useProviderOrderForm"
import { MODO_GRANJA } from "./static"

export const dinero = valor =>
  Number(valor || 0).toLocaleString("es-MX", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })

export const piezas = valor => Number(valor || 0).toLocaleString("es-MX")

/** «4 de septiembre 2026», el título de la cabecera. */
export const etiquetaLarga = fecha => {
  const dia = moment(fecha, "YYYY-MM-DD", true)
  return dia.isValid() ? dia.format("D [de] MMMM YYYY") : ""
}

/** «Vie 4 sep», para las fichas de pedidos del día. */
export const etiquetaCorta = fecha => {
  const dia = moment(fecha, "YYYY-MM-DD", true)
  return dia.isValid() ? _.capitalize(dia.format("ddd D MMM")) : fecha || "—"
}

/** Minutos que quedan de la ventana de pedidos del cliente. */
export const etiquetaCierre = minutos => {
  if (minutos === null || minutos === undefined) return ""
  if (minutos <= 0) return "Fuera de horario"
  const horas = Math.floor(minutos / 60)
  const resto = minutos % 60
  return horas > 0 ? `Cierra en ${horas} h ${resto} min` : `Cierra en ${resto} min`
}

/** Precio por pieza de una oferta en el modo indicado; 0 si no se ofrece. */
export const precioEnModo = (oferta, modo) =>
  modo === MODO_GRANJA ? oferta.pGranja : oferta.pRegion

/**
 * Hora de recepción efectiva: la del borrador si sigue permitida para esa
 * fecha y modo; si no, la primera disponible.
 */
export const horaEfectiva = (horaBorrador, fecha, esLocal, fechaPedido) => {
  const opciones = opcionesHora(fecha, esLocal, fechaPedido)
  if (opciones.some(opcion => opcion.value === horaBorrador)) return horaBorrador
  return opciones[0] ? opciones[0].value : ""
}

/** «2026-09-05 19:00» → «Vie 5 sep 19:00». */
export const etiquetaRecepcion = deliveryDate => {
  const [fecha, hora] = String(deliveryDate || "").split(" ")
  return `${etiquetaCorta(fecha)} ${(hora || "").slice(0, 5)}`.trim()
}
